import { $ } from '../simpli';
import * as Helper from '../helpers';
var ObjectCollection = /** @class */ (function () {
    function ObjectCollection(list, i18nPath) {
        /**
         * Items of the collection
         * @type {Array}
         */
        this.items = [];
        if (list instanceof Array) {
            this.items = list;
        }
        else if (typeof list === 'object') {
            this.items = Helper.listObject(list, i18nPath);
        }
    }
    /**
     * Prepends a empty value into the resource list
     * @param placeholder
     */
    ObjectCollection.prototype.nullableItems = function (placeholder) {
        if (placeholder === void 0) { placeholder = null; }
        return Helper.nullableItems(this.items, placeholder);
    };
    /**
     * Get Resource by ID
     * @param id
     */
    ObjectCollection.prototype.get = function (id) {
        return Helper.getResource(this.items, id);
    };
    /**
     * Filter Resource by IDs
     * @param ids
     */
    ObjectCollection.prototype.getMany = function (ids) {
        return Helper.getManyResource(this.items, ids);
    };
    /**
     * Get the first item of the list
     */
    ObjectCollection.prototype.first = function () {
        return Helper.firstResource(this.items);
    };
    /**
     * Get the last item of the list
     */
    ObjectCollection.prototype.last = function () {
        return Helper.lastResource(this.items);
    };
    /**
     * Add a null item into the begin of the list
     * @param tag
     * @param useI18n
     */
    ObjectCollection.prototype.prependNull = function (tag, useI18n) {
        if (useI18n === void 0) { useI18n = true; }
        return this.prepend(0, useI18n ? $.t(tag) : tag);
    };
    /**
     * Add an item into the begin of the list
     * @param id
     * @param tag
     */
    ObjectCollection.prototype.prepend = function (id, tag) {
        Helper.prependResource(this.items, Helper.buildResource(id, tag));
        return this;
    };
    /**
     * Add an item into the end of the list
     * @param id
     * @param tag
     */
    ObjectCollection.prototype.append = function (id, tag) {
        Helper.appendResource(this.items, Helper.buildResource(id, tag));
        return this;
    };
    /**
     * Shuffle a list of Resource
     */
    ObjectCollection.prototype.shuffle = function () {
        this.items = Helper.shuffleResource(this.items);
        return this;
    };
    /**
     * Reverse a list of Resource
     */
    ObjectCollection.prototype.reverse = function () {
        this.items = Helper.reverseResource(this.items);
        return this;
    };
    /**
     * Add a Resource
     * @param id
     * @param tag
     * @param index
     */
    ObjectCollection.prototype.add = function (id, tag, index) {
        Helper.addResource(this.items, Helper.buildResource(id, tag), index);
    };
    /**
     * Remove a Resource by ID
     * @param id
     */
    ObjectCollection.prototype.remove = function (id) {
        Helper.removeResource(this.items, id);
    };
    return ObjectCollection;
}());
export { ObjectCollection };
//# sourceMappingURL=ObjectCollection.js.map